import { Injectable } from '@angular/core';
import { UserProfile } from 'app/models/user-profile.model';

@Injectable()
export class ConfigService {
    public userProfile: UserProfile = null;
}
